let routes = [];
const routerContext = require.context("./", true, /\.js$/);
routerContext.keys().forEach((route) => {
  if (route.startsWith("./index")) return;
  const routerModule = routerContext(route);
  console.log(routerModule);
  routes = routes.concat(routerModule.default || routerModule);
});
export default routes;
